import React, {Fragment} from 'react'
import Marquee from "react-fast-marquee";

const MarqueSlider = () => {
    return (
        <Fragment>
            <div className="codam-marquee-clip codam-marquee-clip--home pt-75 pb-130 pb-lg-60">
                <Marquee pauseOnHover={true} className="marquee-line">
                    <h3 className="marque-text">기업 맞춤형 IT 솔루션 · 웹 플랫폼 구축 · AI 기반 업무 자동화 · 데이터 인프라 · 클라우드 아키텍처 · 사이버 보안 · 엔터프라이즈 소프트웨어 개발 · 디지털 전환 파트너 · 기업 맞춤형 IT 솔루션 · 웹 플랫폼 구축 · AI 기반 업무 자동화 · 데이터 인프라 · 클라우드 아키텍처 · 사이버 보안</h3>
                </Marquee>
            </div>
        </Fragment>
    )
}

export default MarqueSlider
